module.exports = "/images/feature-birds-eye-view-icon.svg?506d0ad5076d0613f60dd928c9300369";